module.exports = __webpack_public_path__ + "static/media/tf.2e7dc1af.svg";